import { env } from "src/env";

export const BASE_URL = env.REACT_APP_BASE_URL ?? process.env.REACT_APP_BASE_URL ?? "https://localhost:7000";